import { Heart, MessageCircle, Send, CheckCircle2 } from "lucide-react";
import { Phone, seg } from "./primitives";

const FIELDS = [["Full name", "John Smith"], ["Phone", "(406) 555-0123"], ["Interested in", "Home Valuation"]];
const ROWS = [["Sarah K.", "Buying a Home", "Contacted"], ["Mike R.", "Home Valuation", "Booked"]];

function FeedAd({ tap }) {
  return (
    <div className="absolute inset-0 bg-white pt-7 text-slate-900">
      <div className="flex items-center gap-2 px-3 py-2">
        <div className="h-7 w-7 rounded-full bg-gradient-to-br from-electric to-cyan-300" />
        <div className="leading-tight"><p className="text-[11px] font-semibold">Summit Realty Group</p><p className="text-[9px] text-slate-500">Sponsored</p></div>
      </div>
      <p className="px-3 pb-2 text-[11px] leading-snug">Thinking about selling your home? Get your free home valuation today.</p>
      <img src="/images/re-house.jpg" alt="" loading="lazy" className="h-[46%] w-full object-cover" />
      <div className="relative flex items-center justify-between bg-slate-100 px-3 py-2.5">
        <div><p className="text-[9px] uppercase text-slate-500">Free valuation</p><p className="text-[11px] font-semibold">See what your home is worth</p></div>
        <span className="relative rounded-md bg-electric px-3 py-1.5 text-[10px] font-semibold text-white">
          Learn More
          {tap > 0 && tap < 1 && <span className="absolute inset-0 rounded-md ring-4 ring-electric/50" style={{ transform: `scale(${1 + tap * 0.6})`, opacity: 1 - tap }} />}
        </span>
      </div>
      <div className="flex gap-4 px-3 py-2 text-slate-500"><Heart className="h-4 w-4" /><MessageCircle className="h-4 w-4" /><Send className="h-4 w-4" /></div>
    </div>
  );
}

function LeadSheet({ p }) {
  const open = seg(p, 0.28, 0.38);
  const submitted = p > 0.62;
  return (
    <div className="absolute inset-x-0 bottom-0 z-20 rounded-t-2xl bg-white px-4 pb-5 pt-4 text-slate-900 shadow-2xl" style={{ transform: `translateY(${(1 - open) * 105}%)` }}>
      {submitted ? (
        <div className="flex flex-col items-center py-6 text-center"><CheckCircle2 className="h-9 w-9 text-emerald-500" /><p className="mt-2 text-sm font-semibold">Thanks, John!</p><p className="text-[11px] text-slate-500">We'll be in touch shortly.</p></div>
      ) : (
        <>
          <p className="text-sm font-semibold">Get your free home valuation</p>
          <div className="mt-3 space-y-2">
            {FIELDS.map(([label, value], i) => {
              const t = seg(p, 0.38 + i * 0.06, 0.44 + i * 0.06);
              return (
                <div key={label} className="rounded-md border border-slate-200 px-2.5 py-1.5">
                  <p className="text-[9px] text-slate-500">{label}</p>
                  <p className="h-4 text-[11px] font-medium">{value.slice(0, Math.round(t * value.length))}</p>
                </div>
              );
            })}
          </div>
          <div className="mt-3 rounded-md bg-electric py-2 text-center text-[11px] font-semibold text-white" style={{ opacity: p > 0.56 ? 1 : 0.5 }}>Submit</div>
        </>
      )}
    </div>
  );
}

export function StageLeads({ p }) {
  const arrived = seg(p, 0.64, 0.74);
  return (
    <div className="relative flex h-full w-full items-center justify-center gap-4 sm:gap-6">
      <Phone className="h-full shrink-0">
        <FeedAd tap={seg(p, 0.18, 0.3)} />
        <LeadSheet p={p} />
      </Phone>
      <div className="absolute bottom-1 right-1 z-30 rounded-xl border border-electric/40 bg-ink/90 px-3 py-2 text-[11px] text-white backdrop-blur sm:hidden" style={{ opacity: arrived }}>
        <p className="font-mono text-[9px] uppercase tracking-wider text-cyan-300">CRM · new lead</p>John Smith · Home Valuation
      </div>
      <div className="hidden h-[78%] w-[52%] flex-col rounded-2xl border border-white/10 bg-[#0B0D13] p-4 sm:flex">
        <div className="flex items-center justify-between">
          <p className="text-sm font-semibold text-white">Leads</p>
          <span className="font-mono text-[10px] text-slate-400">CRM · example data</span>
        </div>
        <div className="mt-3 grid grid-cols-[1fr_1fr_auto] gap-2 border-b border-white/[0.07] pb-2 font-mono text-[10px] uppercase tracking-wider text-slate-400">
          <span>Name</span><span>Service</span><span>Status</span>
        </div>
        <div className="relative mt-1 space-y-1">
          <div className="grid grid-cols-[1fr_1fr_auto] items-center gap-2 overflow-hidden rounded-lg px-1 text-[12px] transition-colors"
            style={{ maxHeight: `${arrived * 44}px`, opacity: arrived, background: "rgba(0,136,255,0.12)", paddingTop: arrived * 8, paddingBottom: arrived * 8 }}>
            <span className="font-medium text-white">John Smith</span><span className="text-slate-300">Home Valuation</span>
            <span className="rounded-full bg-electric px-2 py-0.5 text-[10px] font-semibold text-white">New</span>
          </div>
          {ROWS.map(([n, s, st]) => (
            <div key={n} className="grid grid-cols-[1fr_1fr_auto] items-center gap-2 px-1 py-2 text-[12px]">
              <span className="text-slate-200">{n}</span><span className="text-slate-400">{s}</span>
              <span className="rounded-full bg-white/[0.06] px-2 py-0.5 text-[10px] text-slate-300">{st}</span>
            </div>
          ))}
        </div>
        <p className="mt-auto text-[11px] text-slate-400">{arrived > 0.9 ? "New inquiry captured · 0:04 ago" : "Waiting for new inquiries…"}</p>
      </div>
    </div>
  );
}
